<template>
  <div class="switch-tab">
    <slot></slot>
    <div class="selected-bg" :style="{ width: itemWidth + 'px', left: itemLeft + 'px' }"></div>
  </div>
</template>

<script setup>
import { ref, provide, watch } from 'vue'
import { CURRENT_VALUE, SET_CURRENT_VALUE, SET_ITEM_SIZE } from './key'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

const currentValue = ref()
const itemWidth = ref(0)
const itemLeft = ref(0)

function setItemSize({ width, left }, flag) {
  // 初始化时，会设置多次
  if (flag == 1) {
    if (itemWidth.value === 0) {
      itemWidth.value = width
    }
    itemLeft.value = 0
  } else if (flag == 2) {
    itemWidth.value = width
    itemLeft.value = left
  }
}


function setCurrentValue(value) {

  currentValue.value = value

  emit('update:modelValue', value)

  emit('change', value)
  // if (value !== currentValue.value) {
  // }
}

watch(() => props.modelValue, (newValue) => {
  currentValue.value = newValue
}, { immediate: true })


provide(CURRENT_VALUE, currentValue)
provide(SET_CURRENT_VALUE, setCurrentValue)
provide(SET_ITEM_SIZE, setItemSize)


</script>


<style scoped lang="scss">
.switch-tab {
  display: flex;
  height: 48px;
  gap: 0;

  background-color: #fff;
  position: relative;
  font-size: 14px;
  font-family: "HarmonyOS Sans SC", sans-serif;

  .selected-bg {
    background: transparent;
    position: absolute;
    left: 0;
    width: 0;
    transition: left 0.2s ease-out;
    height: 100%;
    border-bottom: 2px solid var(--color-primary);
  }
}
</style>
